import React from 'react';

import makeClasses from './SOCardSkeleton.style';

export function SOCardSkeleton() {
  const _classes = makeClasses();

  return (
    <div className={_classes.skeletonCard} aria-hidden='true'>
      <div className={_classes.skeletonHeader}>
        <div className={_classes.skeletonIdentity}>
          <div
            className={`${_classes.skeletonLine} ${_classes.skeletonLineLong}`}
          />
          <div
            className={`${_classes.skeletonLine} ${_classes.skeletonLineShort}`}
          />
        </div>
        <div className={_classes.skeletonTag} />
      </div>
      <div className={_classes.skeletonDateRow}>
        <div className={_classes.skeletonIcon} />
        <div
          className={`${_classes.skeletonLine} ${_classes.skeletonLineMedium}`}
        />
      </div>
    </div>
  );
}
